export default __webpack_public_path__ + "static/media/end-pin.d846cd53.svg";